export default "__VITE_ASSET__0c4bc6e7__"